import {input as appointmentListItemInput} from "DataMap/appointment/listItem";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {SearchAppointmentsListItemDataObject}
 */
export const input = rawData => appointmentListItemInput(rawData);

// @note There is no output function since list is read only.